import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

import Alert from 'UiKit/alert';

import Head from './section/head';
import Filter from './section/filter';
import Table from './section/table';
import FormUpsert from './section/form-upsert';
import LiveAccountProvider, { useLiveAccountState } from './state';
import useResetAllState from './hooks/useResetAllState';

import styles from './styles.module.css';

const LiveAccount = () => {
  const { state } = useLiveAccountState();
  const onResetAllState = useResetAllState();

  useEffect(() => onResetAllState, /* eslint-disable */ []);

  return (
    <Box data-testid="live-account__container" className={styles['live-account__container']}>
      <Head />
      <Filter />
      <Alert {...state?.errorProps} />
      <Table />

      <FormUpsert />
    </Box>
  );
};

const LiveAccountContainer = () => <LiveAccountProvider children={<LiveAccount />} />;

export default LiveAccountContainer;
